/* global Swiper, setSwiperMessage, prefersReducedMotion */

/**
 * Initializes the home banner Swiper carousel and wires up its pause/play toggle button. The
 * button is hidden entirely when the banner only has one slide (nothing to autoplay through).
 * Autoplay starts stopped when the user has requested reduced motion.
 * @returns {void}
 */
function initBannerHome() {
    const reducedMotion = prefersReducedMotion();
    // Contado antes do Swiper inicializar - com loop:true ele duplica slides no DOM, o que
    // inflaria essa contagem se lida depois.
    const slideCount = document.querySelectorAll('.swiper-banner .swiper-wrapper > .swiper-slide').length;
    const bannerSwiper = new Swiper('.swiper-banner', {
        a11y: setSwiperMessage('Banner Principal'),
        autoplay: reducedMotion ? false : {
            delay: 5000
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        keyboard: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        speed: 500,
        breakpoints: {
            992: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        }
    });

    const bannerPauseButton = document.querySelector('.swiper-banner-pause');

    if (slideCount <= 1) {
        bannerPauseButton.hidden = true;
        return;
    }

    if (reducedMotion) {
        const icon = bannerPauseButton.querySelector('i');
        icon.classList.toggle('fa-pause', false);
        icon.classList.toggle('fa-play', true);
        bannerPauseButton.setAttribute('aria-pressed', 'true');
        bannerPauseButton.setAttribute('aria-label', 'Retomar apresentação do banner');
    }

    bannerPauseButton.addEventListener('click', () => {
        const icon = bannerPauseButton.querySelector('i');
        const willPause = bannerSwiper.autoplay.running;

        if (willPause) {
            bannerSwiper.autoplay.stop();
        } else {
            bannerSwiper.autoplay.start();
        }

        icon.classList.toggle('fa-pause', !willPause);
        icon.classList.toggle('fa-play', willPause);
        bannerPauseButton.setAttribute('aria-pressed', willPause);
        bannerPauseButton.setAttribute('aria-label', willPause ? 'Retomar apresentação do banner' : 'Pausar apresentação do banner');
    });
}

if (document.querySelector('.swiper-banner') !== null) {
    initBannerHome();
}

/**
 * Initializes the speakers ("palestrantes") section's Swiper carousel, with responsive
 * slides-per-view breakpoints. When the current breakpoint's slidesPerView is greater than the
 * number of slides (nothing to scroll), Swiper's watchOverflow locks the carousel and the
 * "is-locked" class centers the leftover slides instead of leaving them stuck to the left.
 * @returns {void}
 */
function initPalestrantesSwiper() {
    const palestrantesSwiper = new Swiper('.swiper-palestrantes', {
        a11y: setSwiperMessage('Slide Palestrantes'),
        keyboard: true,
        loop: false,
        navigation: {
            nextEl: '#swiper-palestrantes-next',
            prevEl: '#swiper-palestrantes-prev',
        },
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 500,
        watchOverflow: true,
        breakpoints: {
            650: {
                slidesPerView: 1.6
            },
            992: {
                slidesPerView: 2
            },
            1200: {
                slidesPerView: 3
            }
        }
    });

    palestrantesSwiper.el.classList.toggle('is-locked', palestrantesSwiper.isLocked);
    palestrantesSwiper.on('lock', () => palestrantesSwiper.el.classList.add('is-locked'));
    palestrantesSwiper.on('unlock', () => palestrantesSwiper.el.classList.remove('is-locked'));
}

if (document.querySelector('.swiper-palestrantes') !== null) {
    initPalestrantesSwiper();
}
